import "./ambVoice.css";
import voicePhoto from "../../../assets/text-testimonials/ken-lam.webp";

/* The apply form at the foot of the page, not a mail client. */
const APPLY = "#apply";

/* ⚠️ Wording relayed by Jacob on 2026-09-10 from what the ambassador said,
   tidied into a quote — so it is close to their words but not a verbatim
   transcript. Jacob confirmed on 2026-09-10 that the speaker is Ken, not
   Surya; photo swapped to the headshot we already have for him. Still to
   confirm before this ships — that Ken is happy being quoted this way.
   Once he signs off, delete this note. */
/* `school` is the class line ("Duke '26"). Blank until someone confirms
   Ken's school and year — the attribution assembles itself either way, with
   no stray comma when it is missing. */
const quote = {
  text: "It was exciting to work with a team that was genuinely passionate about solving a problem I’d been living myself. We did a bit of everything: putting up flyers and talking to people on campus, but also thinking through the platform and pitching ideas. They brought me in end to end, and it taught me so much about how a product actually gets built.",
  name: "Ken",
  school: "",
  role: "Campus ambassador",
};

const AmbVoice = () => (
  <section className="amb-section amb-voice">
    <div className="home-container amb-voice-grid">
      <div className="amb-voice-copy">
        <h2 className="amb-voice-title">Hear from RAIN ambassadors</h2>

        <blockquote className="amb-voice-quote">
          &ldquo;{quote.text}&rdquo;
        </blockquote>

        <p className="amb-voice-attr">
          {[quote.name, quote.school].filter(Boolean).join(", ")} &middot;{" "}
          {quote.role}
        </p>

        {/* The button goes to the apply form, so it says so. "Read Ken's
            story" would need a story to point at. */}
        <a className="amb-voice-btn" href={APPLY}>
          Apply now
        </a>
      </div>

      <figure className="amb-voice-photo">
        <img width={800} height={800} decoding="async" src={voicePhoto} alt={quote.name} loading="lazy" />
      </figure>
    </div>
  </section>
);

export default AmbVoice;
